import React from 'react'

export default function SavedPost(props) {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.00058 21C5.82879 20.9995 5.66004 20.9547 5.51058 20.87C5.35611 20.7832 5.22749 20.6569 5.13788 20.504C5.04827 20.3511 5.00089 20.1772 5.00058 20V5.33C4.98706 4.73032 5.21041 4.14946 5.62221 3.71332C6.03402 3.27718 6.60111 3.02089 7.20058 3H16.8006C17.4001 3.02089 17.9671 3.27718 18.3789 3.71332C18.7908 4.14946 19.0141 4.73032 19.0006 5.33V20C18.9995 20.1745 18.9528 20.3457 18.8651 20.4966C18.7774 20.6475 18.6517 20.7727 18.5006 20.86C18.3486 20.9478 18.1761 20.994 18.0006 20.994C17.825 20.994 17.6526 20.9478 17.5006 20.86L11.8306 17.65L6.50058 20.85C6.35013 20.9434 6.17759 20.9951 6.00058 21Z'
        fill='#4E5E91'
      />
    </svg>
  )
}
